import styled from 'styled-components';

import card from '@assets/images/coin-race/info/card.png';

export const SliderWrapper = styled.div`
	margin-top: 20px;

	.swiper-slide {
		height: auto;
	}
`;

export const InfoItem = styled.div`
	position: relative;

	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	border-radius: 4px;

	background-image: url(${card});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

export const InfoItemDescription = styled.div`
	font-size: 16px;
	font-weight: 500;
	display: flex;
	flex-direction: column;
	gap: 8px;
	color: ${({ theme }) => theme.colors.text.title};
`;

export const InfoItemTitle = styled.div`
	font-size: 16px;
	line-height: 20px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const InfoItemDescriptionText = styled.div`
	font-size: 14px;
	line-height: 18px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const InfoItemImage = styled.img`
	width: 68px;
	height: 68px;
	flex-shrink: 0;
`;